query PlatformShow($id: ID!) {
  platform(id: $id) {
    id
    title
    slug
    description
    status
    published
    host
    slugHost
    slugUrl
    url
    logo {
      id
      url
    }
    favicon {
      id
      url
    }
    gaId
    theme {
      palette {
        type
        primary
        secondary
        backgroundColor
      }
      typography {
        fontFamily
        headingFontFamily
      }
    }
    footer {
      title
      subtitle
      social {
        type
        link
      }
    }
    defaultRowSize
    googleSiteVerification
    customTerms {
      label
      url
    }
    customHTML
    customHead
    clientFields {
      type
      name
      label
      required
      options {
        value
        label
      }
      multiple
      placeholder
      helperText
    }
    supportEmail
    showSupportEmail
    showTerms
    showCookieBanner
    hideableHeader
    isLikesEnabled
    isFavoritesEnabled
    isFeaturedVideosEnabled
    isVideoChatEnabled
    isStreamChatEnabled
    organizationId
    organization {
      id
      title
    }
    sudoUrl
    videoProvider
    effectiveVideoProvider
    streamingSettings {
      accountId
      apiTokenMask
      connectedAt
    }
    bunnySettings {
      libraryId
      cdnHostname
      apiKeyMask
      connectedAt
    }
    streamingAvailable
    stripeBillingMode
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
